export function hasKey<O extends object>(obj: O, key: PropertyKey): key is keyof O {
  return key in obj;
}

export function getValue<T>(obj: Record<any, T>, key: string, defaultValue: T): T;
export function getValue<T>(obj: Record<any, T>, key: string): T | undefined;
export function getValue<T>(obj: Record<any, T>, key: string, defaultValue?: T) {
  if (hasKey(obj, key)) {
    return obj[key];
  }

  return defaultValue;
}

export function whereNotNull<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function whereNotEmptyOrNull(value: string | null | undefined): value is string {
  return value !== null && value !== undefined && value?.trim() !== '';
}

export function wherePropertyNotNull<T, K extends keyof T>(obj: T, key: K): obj is T & Record<K, NonNullable<T[K]>> {
  return obj[key] !== null && obj[key] !== undefined;
}

export function assertUnreachable(x: never): never {
  throw new Error(`Unhandled case in switch statement: ${x}`);
}

export function getHTMLInputElementTargetFromEvent(event: Event) {
  const target = event.target as HTMLInputElement;
  return target;
}

export function getFilesFromInputChangeEvent(event: Event) {
  const target = getHTMLInputElementTargetFromEvent(event);
  return target.files;
}

// #region Enum
// Courtesy of https://obaranovskyi.medium.com/top-7-functions-youll-ever-need-to-work-with-enums-in-typescript-d8a75a445f2b
export type Enum = { [s: number]: string };

function isEnumKey<T extends Enum>(enumSrc: T, key: unknown): key is keyof T {
  return Number.isInteger(enumSrc[key as keyof T]);
}

export function enumToKeys<T extends Enum>(enumSrc: T): (keyof T)[] {
  return Object.keys(enumSrc).filter((key: keyof T | any) => isEnumKey(enumSrc, key)) as (keyof T)[];
}

export function enumToValues<T extends Enum>(enumSrc: T): T[keyof T][] {
  return enumToKeys(enumSrc).map((key: keyof T) => enumSrc[key]);
}
// #endregion
